import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./HappyNewYear.module.css";

export default function HappyNewYearPage() {
  const now = new Date();
  const [year] = useState(now.getFullYear());
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    document.title = `Happy New Year ${year} 🎆 | Blake Technologies`;
    const timer = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(timer);
  }, [year]);

  return (
    <div className={styles.page}>
      {/* Animated fireworks glow */}
      <motion.div
        className={styles.fireworksGlow}
        animate={{ opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 6, repeat: Infinity }}
      />

      {/* Center content */}
      <div className={styles.center}>
        <motion.h1
          initial={{ scale: 0.6, rotate: -4, opacity: 0 }}
          animate={{ scale: 1, rotate: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 140 }}
        >
          Happy New Year 🎉
        </motion.h1>

        <motion.h2
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Welcome {year}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          From all of us at <strong>Blake Technologies</strong>,
          here’s to innovation, growth, and bold new ideas.
        </motion.p>

        {/* Live celebration timer */}
        <motion.div
          className={styles.timer}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          🎆 Celebrating for {seconds}s
        </motion.div>

        <div className={styles.actions}>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="https://baiv.blaketechhq.com">
            Enter Dashboard 🚀
          </motion.a>
          <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href="product/ai_vision/docs">
            View Docs 📘
          </motion.a>
        </div>
      </div>

      {/* Rising confetti */}
      <div className={styles.confettiLayer}>
        {[...Array(40)].map((_, i) => (
          <motion.span
            key={i}
            className={styles.confetti}
            initial={{ y: "110vh", opacity: 0, rotate: 0 }}
            animate={{ y: "-10vh", opacity: 1, rotate: 360 }}
            transition={{
              duration: 6 + Math.random() * 6,
              repeat: Infinity,
              delay: Math.random() * 4,
            }}
            style={{ left: `${Math.random() * 100}%` }}
          />
        ))}
      </div>

      {/* Burst fireworks on load */}
      <motion.div
        className={styles.fireworkBurst}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: [0, 1.4, 1], opacity: [0, 1, 0] }}
        transition={{ duration: 2 }}
      />
    </div>
  );
}
